import React from 'react';
import { AppState } from 'src/AppState';
import { MemoPlaceholderRegistrationCertificateBackPoland } from 'src/easyclaim.app.assets/artwork/placeholder/v2/PlaceholderRegistrationCertificateBackPoland';
import { MemoPlaceholderRegistrationCertificateFrontPoland } from 'src/easyclaim.app.assets/artwork/placeholder/v2/PlaceholderRegistrationCertificateFrontPoland';
import { CompanyCheck } from 'src/easyclaim.app.components/common/CompanyCheck';

import {
	MemoPlaceholderRegistrationDocumentFrontSpain,
	MemoPlaceholderRegistrationDocumentRearSpain,
	MemoPlaceholderRegistrationCertificateFront,
	MemoPlaceholderRegistrationCertificateBack,
	PlaceholderRegistrationDocumentV2,
} from '../easyclaim.app.assets/index';
import { ImageFileInputType } from '../easyclaim.app.components/index';
import { ImageSelectionService } from '../easyclaim.app.services';
import { Image } from '../easyclaim.app.services/index';

export interface VehicleInformationState {
	isRegistrationDocumentExampleModalOpen: boolean;
	isRegistrationDocument2ExampleModalOpen: boolean;
}

export function determineNewStateAfterLoadingForRegistrationDocument(
	currentAppState: AppState,
	newRegistrationDocument: Image | undefined
): AppState {
	const isRegistrationDocumentLoading =
		ImageSelectionService.isImageLoading(newRegistrationDocument);
	const isRegistrationDocumentInsideLoading = ImageSelectionService.isImageLoading(
		currentAppState.registrationDocument2
	);

	const isImageLoading = !!isRegistrationDocumentLoading || !!isRegistrationDocumentInsideLoading;

	const newState = Object.assign({}, currentAppState, {
		registrationDocument: newRegistrationDocument,
		isImageLoading: isImageLoading,
	});

	return newState;
}

export function determineNewStateAfterLoadingForRegistrationDocumentInside(
	currentAppState: AppState,
	newRegistrationDocumentInside: Image | undefined
): AppState {
	const isRegistrationDocumentLoading = ImageSelectionService.isImageLoading(
		currentAppState.registrationDocument
	);
	const isRegistrationDocumentInsideLoading = ImageSelectionService.isImageLoading(
		newRegistrationDocumentInside
	);

	const isImageLoading = !!isRegistrationDocumentLoading || !!isRegistrationDocumentInsideLoading;

	const newState = Object.assign({}, currentAppState, {
		registrationDocument2: newRegistrationDocumentInside,
		isImageLoading: isImageLoading,
	});

	return newState;
}

export type RegistrationDocumentSide = 'Front' | 'Back';

export interface VehicleInformationProps extends AppState {
	canAddLaterModal: boolean;
}

export interface RegistrationDocumentResources {
	placeholder: JSX.Element;
	exampleImageSrc: string;
}

export const getRegistrationDocumentResources = (
	side: RegistrationDocumentSide,
	customerShortName: string | null
): RegistrationDocumentResources => {
	return {
		placeholder: getPlaceholderImage(side, customerShortName),
		exampleImageSrc: getExampleImageSrc(side, customerShortName),
	};
};

export const getExampleImageSrc = (
	side: RegistrationDocumentSide,
	customerShortName: string | null
): string => {
	if (side === 'Front') {
		if (customerShortName === 'allianzpt') {
			return '/images/example-registration-document-outer-pt.png';
		} else if (customerShortName === 'mapfrees') {
			return '/images/example-registrationdocument-es-front.jpg';
		} else {
			return '/images/example-registration-document-outer.png';
		}
	} else {
		if (customerShortName === 'allianzpt') {
			return '/images/example-registration-document-inner-pt.jpeg';
		} else if (customerShortName === 'mapfrees') {
			return '/images/example-registrationdocument-es-back.jpg';
		} else {
			return '/images/example-registration-document-inner.png';
		}
	}
};

export const getPlaceholderImage = (
	side: RegistrationDocumentSide,
	customerShortName: string | null
) => {
	if (customerShortName === 'aiges') {
		return <PlaceholderRegistrationDocumentV2 className="photo-placeholder" />;
	} else if (customerShortName === 'mapfrees') {
		if (side === 'Front') {
			return <MemoPlaceholderRegistrationDocumentFrontSpain className="photo-placeholder" />;
		} else {
			return <MemoPlaceholderRegistrationDocumentRearSpain className="photo-placeholder" />;
		}
	} else if (CompanyCheck.isUniqaPL(customerShortName)) {
		if (side === 'Front') {
			return <MemoPlaceholderRegistrationCertificateFrontPoland className="photo-placeholder" />;
		} else {
			return <MemoPlaceholderRegistrationCertificateBackPoland className="photo-placeholder" />;
		}
	} else {
		if (side === 'Front') {
			return <MemoPlaceholderRegistrationCertificateFront className="photo-placeholder" />;
		} else {
			return <MemoPlaceholderRegistrationCertificateBack className="photo-placeholder" />;
		}
	}
};

export const getImageFileInputType = (customerShortName: string | null): ImageFileInputType => {
	const result: ImageFileInputType =
		customerShortName === 'mapfrees'
			? ImageFileInputType.CapturePicture
			: ImageFileInputType.Default;

	return result;
};
